var exports = {};

/**
 * Converts list into array
 */
exports = Array.from;
export default exports;